// Pozycja popovera z detalami wydarzenia względem klikniętego kafelka. Wspólna dla kalendarza
// wydarzeń (calendar-dashboard) i kalendarza zadań (task-calendar) - w obu panel ma tę samą
// szerokość i te same warianty ustawienia.
//
// Kolejność prób: z prawej kafelka, z lewej kafelka, a gdy nie mieści się z żadnej strony -
// wyśrodkowany pod kafelkiem (albo nad nim, jeśli pod nim brakuje miejsca). Trzeci wariant
// wychodzi tylko w widoku dziennym, gdzie kafelek zajmuje całą szerokość siatki: wtedy z prawej
// jest już krawędź ekranu, a z lewej brakuje miejsca na 288 px, więc panel lądował dociśnięty
// do lewej krawędzi, na samym kafelku.
const MARGIN = 8
const GAP = 4

// Czysta funkcja - liczy pozycję z wymiarów, bez dotykania DOM (żeby dała się przetestować).
// rect: prostokąt kafelka, panel: { width, height }, viewport: { width, height }
export function eventPopoverPosition(rect, panel, viewport) {
  const maxLeft = viewport.width - panel.width - MARGIN
  const rightSide = rect.right + MARGIN
  const leftSide = rect.left - panel.width - MARGIN

  if (rightSide <= maxLeft) return { left: rightSide, top: clampTop(rect.top, panel, viewport) }
  if (leftSide >= MARGIN) return { left: leftSide, top: clampTop(rect.top, panel, viewport) }

  // kafelek na całą szerokość - pod nim, wyśrodkowany
  const centered = rect.left + rect.width / 2 - panel.width / 2
  const left = Math.min(Math.max(centered, MARGIN), Math.max(maxLeft, MARGIN))
  let top = rect.bottom + GAP
  if (top + panel.height > viewport.height - MARGIN) top = rect.top - panel.height - GAP

  return { left, top: clampTop(top, panel, viewport) }
}

// Trzyma panel w pionie w granicach okna - wysoki panel przy kafelku pod wieczór wychodziłby poza dół
function clampTop(top, panel, viewport) {
  if (top + panel.height > viewport.height - MARGIN) top = viewport.height - panel.height - MARGIN

  return Math.max(top, MARGIN)
}

// Przesunięcie w poziomie, po którym panel przyklejony do przycisku mieści się w oknie.
// Rozwijany wybór daty przy "Dziś" wisi na prawej krawędzi przycisku, więc na wąskim ekranie
// kalendarz (ok. 310 px) wychodzi poza lewą krawędź i połowa dni jest nieklikalna.
export function panelShiftIntoView(rect, viewportWidth) {
  if (rect.left < MARGIN) return MARGIN - rect.left
  if (rect.right > viewportWidth - MARGIN) return viewportWidth - MARGIN - rect.right

  return 0
}
